<!--

  按钮权限
  by:linlei
  <app-authorize-button
  @click-add="fn"
   />
   attributes:
    customClass
   method:
     click-add
     click-update
     click-delete
     click-export
     click-filter
-->
<template>
  <div :class="[customClass,'add-btn']">
    <slot name="left">
      <div class="add-btn-left">
        <el-button
          v-for="(item,index) in leftBtn"
          :key="index"
          v-waves
          class="filter-item"
          type="primary"
          size="mini"
          @click="btnClick(item.buttonevent || item.url)"
        >
          <svg-icon :icon-class="item.buttonicon||item.icon" />
          <span style="margin-left:3px">{{ item.functionName }}</span>
        </el-button>
      </div>
    </slot>
    <slot name="right">
      <div v-show="showRightButton" class="add-btn-right">
        <el-button
          v-for="(item,index) in rightBtn"
          :key="index"
          v-waves
          class="filter-item"
          type="text"
          size="mini"
          @click.stop="btnClick(item.url)"
        >
          <svg-icon :icon-class="item.icon" />
          <span style="margin-left:3px">{{ item.functionName }}</span>
        </el-button>
        <slot name="check-filter" />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'AuthorizeBtn',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    customClass: {
      type: String,
      default: ''
    },
    showRightButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    leftBtn() {
      if (this.data.length === 0) return []
      return this.data.filter(item => item.isShow && (item.url != 'export' && item.url != 'import' && item.url!='setInterval' && item.url!='rightUpdate' && item.url!='search' && item.url != 'exportBI' && item.url != 'importBI' && item.url != 'exportSO' && item.url != 'importSO'))
    },
    rightBtn() {
      // debugger
      let filterRB = []
      if (this.data.length === 0) {
        return [{ 
          functionName: this.$t('public.more'),
          url: 'FILTER', 
          icon: 'filternew' }]
      } else {
        filterRB = this.data.filter(item => item.isShow && (item.url === 'export' || item.url === 'import' || item.url==='setInterval' || item.url==='rightUpdate' || item.url==='search' || item.url === 'exportBI' || item.url === 'importBI' || item.url === 'exportSO' || item.url === 'importSO'))
        filterRB.push({ 
          functionName: this.$t('public.more'),
          url: 'FILTER', 
          icon: 'filternew' })
        return filterRB
      }
    },
    lang() {
      return this.$store.getters.language
    }
  },
  methods: {
    // allbtnMethods
    btnClick(type) {
      // console.log(type)
      switch (type.toUpperCase()) {
        case 'CREATE':
          this.handleAdd()
          break
        case 'RIGHTUPDATE':
          this.handleRightUpdate()
          break
        case 'FILTER':
          this.handlFilter()
          break
        case 'CLEAR':
          this.handleClear()
          break
        case 'USERFUNCPERMISSON':
          this.handleUserFuncPermisson()
          break
        case 'REFRESHPASSWORD':
          this.handleUpDatePassWord()
          break
        case 'PARTTIMEJOB':
          this.handlePartTimeJob()
          break
        case 'BINDSIM':
          this.bindSim()
          break
        case 'BINDTERMINALSIM':
          this.bindTerminalSim()
          break
        case 'BINDIMPROVE':
          this.bindImprove()
          break
        case 'BINDHISTORY':
          this.lookBindHistory()
          break
        case 'TERMINALREPLACE':
          this.terminalReplace()
          break
        case 'ADDPEOPLE':
          this.handleAddPeople()
          break
        case 'SETORDINARYTASK':
          this.handledsetCommonTask()
          break
          // setEmergencyTask
        case 'SETEMERGENCYTASK':
          this.handledsetSelfTask()
          break
        case 'LOOKBOOK':
          this.handleLookBook()
          break
        case 'ADDTASK':
          this.handleAddTask()
          break
        case 'DELETETASK':
          this.handleDeleteTask()
          break
        case 'SETPARAM':
          this.handleSetParam()
          break
        case 'CARNUMBERIMPORT':
          this.handleCarNumberImport()
          break
        case 'SAVEALL':
          this.handleSaveall()
          break
        case 'LOOK':
          this.handleLook()
          break
        case 'LOOKUNSUCCESS':
          this.handleLookUnsuccess()
          break
        case 'SETINTERVAL':
          this.handleSetInterval()
          break
        case 'ADDOBDTASK':
          this.handleAddOBDTask()
          break
        default:
          // 禁止后续按钮使用上面的方式
          this.$emit(`click-${type.toLowerCase()}`)
          break
      }
    },
    // 新增
    handleAdd() {
      this.$emit('click-add')
    },
    // 更新
    handleRightUpdate() {
      this.$emit('click-right-import')
    },
    // 过滤
    handlFilter() {
      this.$emit('click-filter')
    },
    // 查看用户功能权限
    handleUserFuncPermisson() {
      this.$emit('click-user-func-perimssion')
    },
    // 重设密码
    handleUpDatePassWord() {
      this.$emit('click-updatepwd')
    },
    // 查看绑定记录
    lookBindHistory() {
      this.$emit('click-car-bind-history')
    },
    // 设置普通任务
    handledsetCommonTask() {
      this.$emit('click-setCommonTask')
    },
    // 设置紧急任务
    handledsetSelfTask() {
      this.$emit('click-setSelfTask')
    },
    // 查看说明书
    handleLookBook() {
      this.$emit('click-look-book')
    },
    //查看未完成的指令
    handleLookUnsuccess(){
      this.$emit('click-look-unsuccess')
    },
    // 终端批量设置 添加任务
    handleAddTask() {
      this.$emit('click-add-task')
    },
    // 删除任务
    handleDeleteTask() {
      this.$emit('click-delete-task')
    },
    // 设置参数权限
    handleSetParam() {
      this.$emit('click-setParam')
    },
    // 车牌号导入
    handleCarNumberImport() {
      this.$emit('click-carNumberImport')
    },
    // 保存全部
    handleSaveall() {
      this.$emit('click-saveall')
    },
    // 查看
    handleLook() {
      this.$emit('click-look')
    },
    // 10s刷新一次
    handleSetInterval() {
      this.$emit('click-setInterval')
    },
    handleAddOBDTask() {
      this.$emit('click-addOBDTask')
    }
  }
}

</script>
<style lang="scss" scoped>
svg{
  font-size: 12px;
}
ul{
  margin: 0;
}
.add-btn-right .el-button--small{
  padding:8px 10px;
  font-size: 12px;
  color: #515c60
}
.add-btn-right .el-button--small:hover{
  background: #fff;
  border:1px solid #fff;
}
</style>
